/**
 * @class NumApp
 * @extends HTMLElement
 * @description A custom web component to manage the state of the drawer with improved structure and scalability.
 */
class NumApp extends HTMLElement {
  static get observedAttributes() {
    return ['open-menu', 'open-search', 'open-cart'];
  }

  constructor() {
    super();
    this._state = {
      'open-menu': false,
      'open-search': false,
      'open-cart': false,
    };
  }

  connectedCallback() {
    this._elements = {
      'open-menu': {
        button: this.querySelector('#BurgerButton'),
        drawer: this.querySelector('#MenuDrawer'),
      },
      'open-search': {
        button: this.querySelector('#SearchButton'),
        drawer: this.querySelector('#SearchDrawer'),
      },
      'open-cart': {
        button: this.querySelector('#CartButton'),
        drawer: this.querySelector('#CartDrawer'),
      },
    };

    this._attachEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (this._state.hasOwnProperty(name)) {
      this._state[name] = newValue === 'true';
      this._toggleDrawer(name);
      if (this._state[name]) {
        this._closeOtherDrawers(name);
      }
      this._updateBodyScroll();
    }
  }

  openDrawer(name) {
    this.setAttribute(name, 'true');
  }

  _toggleDrawer(name) {
    const { drawer, button } = this._elements[name];
    if (!drawer || !button) return;
    if (name === 'open-cart') {
      this._state[name] ? drawer.open(button, document.querySelector('.drawer__close')) : drawer.close();
      button.setAttribute('data-open', this._state[name]);
    } else {
      this._state[name] ? drawer.open() : drawer.close();
      button.setAttribute('data-open', this._state[name]);
    }
  }

  _toggleState(name, event) {
    event.preventDefault();
    this.setAttribute(name, String(!this._state[name]));
  }

  _closeState(name) {
    this.setAttribute(name, 'false');
  }

  _closeOtherDrawers(exceptName) {
    Object.keys(this._elements).forEach((name) => {
      if (name !== exceptName) {
        this._closeState(name);
      }
    });
  }

  _updateBodyScroll() {
    const isAnyDrawerOpen = Object.values(this._state).some((state) => state);
    document.body.style.overflow = isAnyDrawerOpen ? 'hidden' : '';
  }

  _attachEventListeners() {
    Object.keys(this._elements).forEach((name) => {
      const { button, drawer } = this._elements[name];
      if (button) {
        button.addEventListener('click', (event) => this._toggleState(name, event));
      }
      if (drawer) {
        drawer.addEventListener('onClose', () => this._closeState(name));
      }
    });
  }
}

customElements.define('num-app', NumApp);
